export class MenuStrategy {
  private readonly menuTitle:  string;
  private readonly pageTitle:  string;
  private readonly pageComponent : string;

  constructor(menuTitle: string, pageTitle: string, pageComponent: string ) {
    this.menuTitle = menuTitle;
    this.pageTitle = pageTitle;
    this.pageComponent = pageComponent;
  }

  public getMenuTitle(): string {
    return this.menuTitle;
  }

  public getPageTitle(): string {
    return this.pageTitle;
  }

  public getPageComponent(): string {
    return this.pageComponent;
  }

}
